<div class="container">
  <div class="app-loading" *ngIf="appLoading">
    <div class="logo">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <span>Caricamento...</span>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1 rtl class="main-heading">Questionario</h1>
    </div>
  </div>
  <div *ngIf="!istanzaQuestionario">
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p><img src="assets/cupido.png"/></p>
    </div>
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p>Nessuna domanda presente su questa pratica.</p>
    </div>
  </div>
  <div class="row" *ngIf="istanzaQuestionario">
    <div class="col">
      <form [formGroup]="formQuestionario" #formQuestionarioRef="ngForm" (ngSubmit)="inviaQuestionario()">
        <div *ngFor="let domanda of domande" class="form-row">
          <mydyn-domanda [domanda]="domanda" [form]="formQuestionario"></mydyn-domanda>
        </div>
        <div>
          <p class="errorMessage" *ngIf="!formQuestionario.valid">Rispondi a tutte le domande per continuare.</p>
          <button type="submit" mat-raised-button color="primary" [disabled]="!formQuestionario.valid" >Invia Questionario</button>
          <button type="reset" mat-button color="warn">Reset</button>
        </div>
      </form>
    </div>
  </div>
</div>
